import React, { useEffect } from "react";
// import YouTubeEmbed from "./YouTubeEmbed";
import { constants } from "../../constants/constants";

const UploadFile = ({
  selectedFile,
  setSelectedFile,
  className,
  type = "image", // "image" | "video" | "link"
  label,
  placeholder,
  mandatory,
  width = 1920,
  height = 826,
}) => {
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
  };

  useEffect(() => {
    if (selectedFile && typeof selectedFile === "string") {
      // keep selectedFile as is if already a string (URL or link)
      return;
    }
  }, [selectedFile]);
  const renderPreview = () => {
    if (!selectedFile) return null;

    // If it's a File object, use URL.createObjectURL
    if (selectedFile instanceof File) {
      const objectUrl = URL.createObjectURL(selectedFile);
      return type === "image" ? (
        <img
          src={objectUrl}
          alt="preview"
          style={{ maxWidth: 200, maxHeight: 100 }}
        />
      ) : (
        <video controls src={objectUrl} style={{ height: 100, width: 200 }} />
      );
    }

    // If it's a string, only render if it seems like a valid URL
    if (typeof selectedFile === "string") {
      const fileUrl = selectedFile.startsWith("http")
        ? selectedFile
        : `${constants.MEDIAURL}/${selectedFile}`;

      // Optional: you could add a HEAD request to check if file exists before rendering
      return type === "image" ? (
        <img
          src={fileUrl}
          alt="preview"
          style={{ maxWidth: 200, maxHeight: 100 }}
        />
      ) : (
        <video controls src={fileUrl} style={{ height: 100, width: 200 }} />
      );
    }

    return null;
  };

  return (
    <div className={className || "col-12"}>
      <div className="fieldrow">
        <label className="f_label">
          {label}
          {mandatory && <span style={{ color: "red" }}> {mandatory}</span>}
        </label>

        {type === "link" ? (
          <input
            required
            className="f_input"
            type="text"
            value={selectedFile || ""}
            onChange={(e) => setSelectedFile(e.target.value)}
            placeholder={placeholder}
          />
        ) : (
          <div className="upload_box">
            <input
              type="file"
              onChange={handleFileChange}
              accept={type === "image" ? "image/*" : "video/*"}
            />
            <i className="ri-upload-cloud-2-line"></i>
            <span>{placeholder}</span>
            <span>{`Width: ${width}, Height: ${height}`}</span>
          </div>
        )}
      </div>

      <div className="fieldrow uploaded_item">
        <ul>
          {selectedFile && (
            <li>
              {renderPreview()}
              <button onClick={handleRemoveFile} type="button">
                <i className="ri-close-line"></i>
              </button>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default UploadFile;
